<template>
  <div class="is-hidden-mobile" data-track="Trust Index and Industry Ranking Analytics view">

    <!-- Header Section Begins -->
    <div class="level page-info-section">
      <div class="level-left">
        <div v-if="isActiveTab('AnalyticsTrustIndex')" class="title is-marginless is-paddingless review-invite-head">TrustIndex</div>
        <div v-else class="title is-marginless is-paddingless review-invite-head">Industry Rank</div>
      </div>
      <div class="level-right">
        <date-select-filter dataTrack="Review Invites Analytics change date" :filter_items="filters.dateFilter.props" :styleProp="filters.dateFilter.styleProp" @onDateChange="handleDateChange"/>
        <a data-track="Trust Index Analytics export" class="button hollow-btn is-hidden-mobile" @click="exportAnalytics" :disabled="!isPaidUser">EXPORT</a>
        <a data-track="Trust Index Analytics export" class="button hollow-btn is-hidden-tablet is-fullwidth" @click="exportAnalytics" :disabled="!isPaidUser">EXPORT</a>
      </div>
    </div>
    <!-- Header Section Ends -->

    <hr class="horizontal-row">

    <!-- Tabs Section Starts-->
    <div class="custom-tabs">
      <div class="tabs is-boxed custom-tabs__tab-box">
        <ul class="custom-tabs__group">


          <!-- Trust Index Tab Begins -->
          <li :class="{'is-active': isActiveTab('AnalyticsTrustIndex')}">
            <router-link class="custom-tabs__link" to="/analytics/trust-index-and-industry/trust-index">
              <span class="custom-tabs__text">TrustIndex</span>
            </router-link>
          </li> <!-- Trust Index Tab Ends -->

          <!-- Industry Rank Tab Begins -->
          <!--          <li :class="{'is-active': isActiveTab('AnalyticsIndustryRanking')}">-->
          <!--            <router-link class="custom-tabs__link" to="/analytics/trust-index-and-industry/industry-ranking">-->
          <!--              <span class="custom-tabs__text">Industry ranking</span>-->
          <!--            </router-link>-->
          <!--          </li>-->
          <!-- Industry Rank Tab Ends -->

        </ul>
      </div>
      <div class="custom-tabs__content-box">
        <router-view></router-view>
      </div>
    </div>
    <!-- Tabs Section Ends-->

  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
import misc from '@/mixins/misc.js'
import {DateSelectFilter} from '@/components'

export default {
  mixins: [misc],
  components: {
    DateSelectFilter
  },
  data () {
    return {
      dateFilter: {},
      filters: {
        starRating: null,
        dateFilter: {
          label: 'last_6_months',
          endDate: null,
          startDate: null,
          styleProp: {},
          props: [{
            name: 'date',
            label: 'Date',
            showApplyBtn: true,
            default: {type: 'months', value: 6, selected: 'Last 6 months'}, // moment.js placeholder in type
            disabled: [],
            elements: ['Previous month', 'Last 6 months', 'Last 12 months', 'Custom']
          }]
        }
      }
    }
  },
  created () {
    this.setUpgradedPackage()

    this.$on('getSelectedDates', key => {
      if (this.dateFilter.startDate !== undefined && this.dateFilter.endDate !== undefined) {
        if (key === 'AnalyticsIndustryRanking') {
          this.$emit('onDateChangeForIndustryRankTab', this.dateFilter)
        } else {
          this.$emit('onDateChangeForTrustIndexTab', this.dateFilter)
        }
      }
    })
  },
  methods: {
    isActiveTab (tab) {
      return this.openActiveTabForURL(this.$router.currentRoute.name, tab)
    },
    /**
     * If user having to Free/Lite package
     * @return {void}
     */
    setUpgradedPackage () {
      /** If user having Free package, set default filter to previous months */
      if (this.userInfo.subscription.name === 'Free') {
        this.filters.dateFilter.styleProp = 'height: 224px;'
        this.filters.dateFilter.props[0].default.value = 1
        this.filters.dateFilter.props[0].default.selected = 'Previous month'
        this.filters.dateFilter.props[0].disabled = ['Last 6 months', 'Last 12 months', 'Custom']
        this.filters.dateFilter.props[0].showApplyBtn = false
      }
    },
    /**
     * Handle Date Dropdown Filter
     * @param {object} dateFilter Date data to sort on
     * @return {void}
     */
    handleDateChange (dateFilter) {
      let that = this
      setTimeout(function () {
        that.dateFilter = dateFilter
        that.$emit('onDateChangeForTrustIndexTab', dateFilter)
        that.$emit('onDateChangeForIndustryRankTab', dateFilter)
      }, 500)
    },
    /**
     * Get link to export trust index or industry rank analytics data
     * @return {string}
     */
    exportAnalytics () {
      if (this.isPaidUser) {
        if (this.isActiveTab('AnalyticsIndustryRanking')) {
          window.open(process.env.API_URL + `/analytics/${this.businessSlug}/export-industry-ranking-analytics?startDate=${this.dateFilter.startDate}&endDate=${this.dateFilter.endDate}&token=${localStorage.getItem('auth_token')}`, '_blank')
        } else {
          window.open(process.env.API_URL + `/analytics/${this.businessSlug}/export-trust-index-analytics?startDate=${this.dateFilter.startDate}&endDate=${this.dateFilter.endDate}&token=${localStorage.getItem('auth_token')}`, '_blank')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utilities/_colors.scss";

.level .level-right a {
  width: 130px;
  height: 37px;
}

.horizontal-row {
  margin-top: 0;
  margin-bottom: 1rem;
  margin-left: -5%;
  margin-right: -5%;
}

.review-invite-head {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #3b3c3d;
}

.page-info-section {
  position: relative;
  margin-bottom: 0.7rem;
}

.page-info-section .level-right .padding-bottom-0 {
  width: 302px;
  padding: 0;
  margin-right: 15px;
}

.page-info-section .dropdown-trigger button {
  padding-left: 20px !important;
}

/* Tabs CSS Begins */
.custom-tabs__tab-box {
  margin-bottom: -1px;
}

.custom-tabs__group {
  border: none;
}

.tabs.is-boxed a.custom-tabs__link {
  border: 1px solid rgba(88, 89, 91, 0.32);
  border-radius: 0;
  width: 193px;
  height: 45px;
  padding: 0;
  margin-right: 5px;
}

.tabs.is-boxed a.custom-tabs__link:hover {
  background-color: unset
}

.tabs.is-boxed li.is-active a.custom-tabs__link {
  background-color: #fafafa;
}

.custom-tabs__text {
  opacity: 0.5;
  font-size: 11px;
  color: #58595b;
}

.is-active .custom-tabs__text {
  opacity: 1;
  color: color('blue-dark');
}

.custom-tabs__content-box {
  border: 1px solid rgba(88, 89, 91, 0.32);
  background-color: #fafafa;
  padding: 20px;
}

/* Tabs CSS Ends */
</style>
<style>
div#sideBar .is-padding-top-0 {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/analytics/trust-index-and-industry-ranking/TrustIndexIndustryRankingPage.vue